import { Alert } from "antd";

export const GuaranteePeriodAlert = ({
  workedDays,
  guaranteeDays = 0,
  isWorkingDays = false,
  style = {},
}) => {
  const dayType = isWorkingDays ? "working days" : "calendar days";

  return (
    <Alert
      showIcon
      type="warning"
      className="alert-message-only"
      style={style}
      message={`Guarantee period in contract is ${guaranteeDays} ${dayType}, this candidate has worked a total of ${workedDays} ${dayType}.`}
    />
  );
};
